import { HEAD_TAG_MARKER as e, serializeJsonLd as t } from "@maat/api-main/types";
//#region src/applyHeadTags.ts
var n = `script[type="application/ld+json"][${e}]`, r = (t, n, r, i) => {
	let [a, ...o] = Array.from(t.querySelectorAll(n));
	o.forEach((e) => e.remove());
	let s = a ?? t.appendChild(r());
	return s.setAttribute(e, ""), i(s), s;
}, i = (e, t, n) => {
	e.getAttribute(t) !== n && e.setAttribute(t, n);
}, a = (a, o) => {
	let s = /* @__PURE__ */ new Set();
	for (let e of o) if (e.kind === "title") a.title !== e.text && (a.title = e.text);
	else if (e.kind === "meta") s.add(r(a.head, `meta[${e.attr}="${e.key}"]`, () => {
		let t = a.createElement("meta");
		return t.setAttribute(e.attr, e.key), t;
	}, (t) => i(t, "content", e.content)));
	else if (e.kind === "link") s.add(r(a.head, `link[rel="${e.rel}"]`, () => {
		let t = a.createElement("link");
		return t.setAttribute("rel", e.rel), t;
	}, (t) => i(t, "href", e.href)));
	else {
		let i = () => {
			let e = a.createElement("script");
			return e.setAttribute("type", "application/ld+json"), e;
		}, o = t(e.json);
		s.add(r(a.head, n, i, (e) => {
			e.textContent !== o && (e.textContent = o);
		}));
	}
	a.head.querySelectorAll(`[${e}]`).forEach((e) => {
		s.has(e) || e.remove();
	});
};
//#endregion
export { a as applyHeadTags };
